import events from '../events';
import {animated} from './execution';
import {noop} from '../lang/function';
import {isAbsent, isString} from '../lang/is';
import {max} from '../lang/number';
import {screenSubscribe, screenWidth, screenHeight} from './screen';

let
    handled = false,
    width = screenWidth(),
    height = screenHeight();

const
    publisher = events('updated'),
    publish = publisher.publish,
    scrollSubscribe = publisher.subscribe,

    left = () => (
        max(document.body.scrollLeft || 0,
            document.documentElement.scrollLeft || 0)),

    top = () => (
        max(document.body.scrollTop || 0,
            document.documentElement.scrollTop || 0)),

    update = () => {
        publish.updated({
            left: left(),
            top: top()
        });
    },

    bounds = element => {
        const {left, right, top, bottom, width, height} = element.getBoundingClientRect();

        return {
            left,
            right,
            top,
            bottom,
            ...isAbsent(width) ? {width: right - left} : {width},
            ...isAbsent(height) ? {height: bottom - top} : {height}
        };
    },

    scrollLeft = (element, relative) => (
        element ?
            bounds(element).left + (relative ? 0 : left()) :
            left()),

    scrollRight = (element, relative) => (
        element ?
            bounds(element).right + (relative ? 0 : left()) :
            left() + width),

    scrollTop = (element, relative) => (
        element ?
            bounds(element).top + (relative ? 0 : top()) :
            top()),

    scrollBottom = (element, relative) => (
        element ?
            bounds(element).bottom + (relative ? 0 : top()) :
            top() + height),

    scrollWidth = element => (
        bounds(element || document.body).width),

    scrollHeight = element => (
        bounds(element || document.body).height),

    toXY = (x, y) => {
        (window.scroll || window.scrollTo || noop)(x || 0, y || 0);
    },

    toElement = (element, offset) => {
        element = (
            isString(element) ?
                document.getElementById(element) :
                element);
        if (element) {
            toXY(scrollLeft(), scrollTop(element) + (offset || 0));
        }
    };

update();
screenSubscribe.updated(({width: w, height: h}) => {
    handled = false;
    width = w;
    height = h;
    update();
});
window.addEventListener('scroll', () => {
    if (!handled) {
        handled = true;
        animated(() => {
            handled = false;
            update();
        });
    }
});

export {
    scrollSubscribe,
    scrollLeft,
    scrollRight,
    scrollTop,
    scrollBottom,
    scrollWidth,
    scrollHeight,
    toXY,
    toElement
};
